
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData, resolveImage } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';


function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            // Sin menu en disco todavia: no reventar la app entera.
            if (!items?.value?.data) return;
            const data = items.value.data;
            setMenus(data);
        });
    }, []);

    
     const fetchImage = async (id) => {
            return resolveImage(id);
     };
    
    const Item = (props) => {
        const { item } = props;
        const [image, setImage] = useState(false);
                useEffect(() => {
                    fetchImage(`menu-cat-${item.id}`).then((url) => {
                        if (url) {
                            setImage(url);
                            
                        }
                    });
                }, []);
        
        return <div  style={{
                                display: 'flex',
                                alignItems: "center",
                                justifyContent: 'center',
                                width: 340,
                                position: "relative"
                            }}
                                onClick={() => { 
                                    setShowListProduct(true)
                                    setdishs(item)
                                }}
                                >
                                    {/* fontFamily: 'WallAxe', */}
                                <p className='text-shadow' style={{position: 'absolute',  color: 'white', fontWeight: "900",fontSize: 30}}>{item.name}</p>
            <img
                onContextMenu={(e) => e.preventDefault()}
                                    src={image}
                                    style={{
                                        marginTop: 10,
                                        width: '100%',
                                        height: 210,
                                          pointerEvents: 'none',
                                        objectFit: 'cover',
                                        borderRadius: 20,
                                    }}
                                />

                            </div>
                            
    }
    return (
        <div style={{ position: 'absolute', top: 1, left: 0, width: '100%', height: '100%', zIndex: 9999 }}>
            <LayoutContent showLamp={ false} showBack={true} showImageTop={false}  setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={setShowSpecials}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                        {menus.map((item, key) => {
                            if (![443, 444, 445, 594, 446, 447, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567, 597].includes(item.id)) {
                                return <Item item={item} key={key} />
                            }
                            
                        })}
                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                

                <img
                    src={require('./assets/image.png')}
                    style={{
                    width: 200,
                    height: 350,
                    objectFit: 'contain',
                    position: 'absolute',
                    bottom: 0,
                    right: -20,
                    zIndex: 1,
                    }}
                />
                
            </LayoutContent>
        </div>
    );
}
export default Index;